@if (isShowFooter()) {
  <div class="mbs-footer">
    <div class="row g-0 mbs-footer-inner">
      @if (rebrandingActivated()) {
        <div class="col-12 mbs-footer_logo justify-content-center">
          <span class="mbs-footer_logo-link">
            <img
              src="{{ footerLogoImage() }}"
              alt=""
              class="mbs-footer_logo-img" />
          </span>
        </div>
      } @else {
        <div class="col-12 mbs-footer_logo justify-content-center">
          <a
            href="https://www.msp360.com"
            target="_blank"
            class="mbs-footer_logo-link">
            <img
              [src]="defaultFooterLogoImage"
              alt="MSP360"
              class="mbs-footer_logo-img mbs-footer_logo-msp360" />
          </a>
        </div>
      }
    </div>
  </div>
}
